import React from "react";
import { ChartWrap, FirstHalf, SecondHalf, Title, SubTitle, Text, ButtonBox, TextColor } from "./styled";
import Button from "shared/Button";
import Image from "next/image";
import { colors } from "styles/colors";

import { useRenderDevice } from "helpers/hooks/useRenderDevice";

const Chart = ({ isLogin, isCreator, becomeCreator }) => {
  const isDesktop = useRenderDevice({ min: 769 });

  return (
    <ChartWrap>
      {!isDesktop && (
        <Title>
          We only succeed <br />
          <SubTitle color="red">when you do</SubTitle>
        </Title>
      )}
      <FirstHalf />
      <SecondHalf>
        {isDesktop && (
          <Title>
            We only succeed <br />
            <SubTitle color="red">when you do</SubTitle>
          </Title>
        )}
        <Text fontSize="18">
          <Image src={`/images/card-check.png`} alt="check" width={26} height={26} quality={100} />
          <span>Free to sign up</span>
        </Text>
        <Text fontSize="18">
          <Image src={`/images/card-check.png`} alt="check" width={26} height={26} quality={100} />
          <span>No monthly service fees.</span>
        </Text>
        <Text fontSize="18">
          <Image src={`/images/card-check.png`} alt="check" width={26} height={26} quality={100} />
          <span>Creators keep 80% of all sales revenue*</span>
        </Text>
        <Text fontSize="18">
          <Image src={`/images/card-check.png`} alt="check" width={26} height={26} quality={100} />
          <span>Ownership. You own your content, not us.</span>
        </Text>
        <ButtonBox>
          {isLogin && isCreator ? null : (
            <Button
              bdButton={colors.WHITE}
              color={colors.RED}
              textColor={colors.WHITE}
              text="Become Creator"
              stylType="primary"
              onClick={becomeCreator}
            />
          )}
          <Text color="gray" fontSize="16">
            *less credit card processing fees, typically <TextColor> ~3%</TextColor>
          </Text>
        </ButtonBox>
      </SecondHalf>
    </ChartWrap>
  );
};

export default Chart;
